<template>
  <CContainer class="mt-4">
    <CRow class="mb-2">
      <CCol col="sm-6">
        <h4>Total Deuda: $<strong>{{ formatter.format(directoryAccountStatusDataTotalDebt) }}</strong></h4>
      </CCol>
      <CCol col="6" sm="6" class="d-flex">
        <CDropdown 
          toggler-text="Descargar" 
          title="Descarga de archivos" 
          class="mr-2" 
          add-toggler-classes="btn-outline-info">
          <CDropdownItem class="text-success" @click="downloadStatementAccount('xls')">
            <Icon icon="ri:file-excel-2-line" class="mr-2" width="24" />
            Excel
          </CDropdownItem>
          <CDropdownItem class="text-danger" @click="downloadStatementAccount('pdf')">
            <i class="bi bi-file-earmark-pdf h4 mr-2"></i>
            <span class="mb-2">PDF</span>
          </CDropdownItem>
        </CDropdown>
        <!-- <CButton 
          color="success" 
          variant="outline" 
          class="mr-2" 
          @click="downloadStatementAccount()">
          <CIcon name="cil-cloud-download" class="mr-2" />
          <span>Excel</span>
          <CSpinner 
            size="sm" 
            class="aling-middle mx-2"
            v-show="loading_excel" />
        </CButton> -->
        <!-- <CButton 
          color="danger" 
          variant="outline" 
          class="mr-2" >
          <CIcon name="cil-cloud-download" class="mr-2" />
          <span>PDF</span>
          <CSpinner
            size="sm"
            class="align-middle mx-2" 
            v-show="loading_pdf" />
        </CButton> -->
        <CButton 
          color="s3purple" 
          variant="outline" 
          class="mr-2"
          @click="showRightSideBar = true">
          <i class="bi bi-envelope-check h5 mr-2"></i>
          <span>Enviar</span>
        </CButton>
      </CCol>
    </CRow>
    <CDataTable
        hover
        pagination
        :fields="fields"
        :items="directoryAccountStatusData"
        :items-per-page="itemsPerPage">
        <template #Documento="{item}">
          <td>
            <div>
              <h5>
                {{ item.Documento }}
              </h5>
              <span class="small text-muted">
                {{ item.Tipo_Documento }}
              </span>
            </div>
          </td>
        </template>
        <template #Fecha_Emision="{item}">
          <td>
            <div>
              <i class="bi bi-calendar3 text-success mr-1"></i>
              {{ item.Fecha_Emision }}
            </div>
          </td>
        </template>
        <template #Fecha_Vencimiento="{item}">
          <td>
            <div>
              <i class="bi bi-calendar3 text-danger mr-1"></i>
              {{ item.Fecha_Vencimiento }}
            </div>
          </td>
        </template>

        <template #Valor_Total="{item}">
          <td>
            <div class="d-flex justify-content-end">
              ${{ formatter.format(item.Valor_Total, 0) }}
            </div>
          </td>
        </template>
        <template #Valor_Retenciones="{item}">
          <td>
            <div class="d-flex justify-content-end">
              ${{ formatter.format(item.Valor_Retenciones, 0) }}
            </div>
          </td>
        </template>
        <template #Valor_Abonos="{item}">
          <td>
            <div class="d-flex justify-content-end">
              ${{ formatter.format(item.Valor_Abonos, 0) }}
            </div>
          </td>
        </template>
        <template #Valor_Saldo="{item}">
          <td>
            <div class="d-flex justify-content-end">
              <CBadge color="success" class="h6">
                ${{ formatter.format(item.Valor_Saldo, 0) }}
              </CBadge>
            </div>
          </td>
        </template>
    </CDataTable>

    <RightSideBar :show="showRightSideBar" class="bg-white">
      <div class="align-center mb-3">
        <h2>Listado de correos</h2>
      </div>
      <div>
        <CInput 
          label="Correo Electrónico" 
          class="col-sm-10 d-inline-block" 
          addLabelClasses="text-muted font-weight-bold text-capitalize"
          maxlength="200"
          :value.sync="correoElectronico">
        </CInput>
        <CButton 
          color="dark" 
          variant="outline" 
          @click="addMailToList()">
          <i class="bi bi-envelope-plus h4"></i>
        </CButton>
        <CListGroup class="col-sm-12" v-if="listCorreos.length">
          <CListGroupItem v-for="(email, index) in listCorreos" :key="index">
            <a href="#" @click="listCorreos.splice(index, 1)">
              <CIcon name="cil-trash" class="text-danger mr-2"></CIcon>
            </a>
            {{ email }}
          </CListGroupItem>
        </CListGroup>
      </div>
      <div class="d-flex justify-content-center mt-3">
        <CButton
          color="info"
          variant="outline"
          class="d-inline-block mr-2"
          :class="listCorreos.length ? '' : 'disabled'"
          :disabled="!listCorreos.length"
          @click="sendMailStatementAccount()">
          <i class="bi bi-send"></i>
          <span class="align-middle mx-2">Enviar</span>
          <CSpinner 
            size="sm" 
            class="aling-middle mx-2"
            v-show="loading_email" />
        </CButton>
        <CButton
          color="danger"
          variant="outline"
          class="mr-2 d-inline-block"
          @click="(e) => {
            e.stopPropagation()
            showRightSideBar = null
          }">
          <CIcon name="cil-x-circle"/>
          <span class="align-middle mx-2">Cancelar</span>
        </CButton>
      </div>
    </RightSideBar>    
  </CContainer>
</template>
<script>
  import { Icon } from "@iconify/vue2";
  import { formatter } from '../../../../general'
  import RightSideBar from "../../../containers/RightSideBar.vue"
  import {
    downloadFileObject,
    dataGridEstadoCuentaCliente, 
    dataGridEstadoCuentaProveedor
  } from '../../../../api'
  import { 
    enviarEstadoCuenta,
    descargaEstadoCuentaExcel
  } from "../../../../apiReports"

  const fields = [
    { 
      key: 'Documento',
      _style:'text-align:center;'
    },
    { 
      key: 'Fecha_Emision', 
      label: 'Emisión',
      _style:'text-align:center;'
    },
    { 
      key: 'Fecha_Vencimiento', 
      label: 'Vencimiento',
      _style:'text-align:center;'
    },
    { 
      key: 'Valor_Total', 
      label: 'Total',
      _style:'text-align:center;'
    },
    { 
      key: 'Valor_Retenciones', 
      label: 'Retenciones',
      _style:'text-align:center;'
    },
    { 
      key: 'Valor_Abonos', 
      label: 'Abonos',
      _style:'text-align:center;'
    },
    { 
      key: 'Valor_Saldo', 
      label: 'Saldo',
      _style:'text-align:center;'
    }
  ]

  export default {
    data() {
      return {
        formatter,
        loading_excel: false,
        loading_email: false,
        showRightSideBar: null,
        itemsPerPage: 10,
        fields,
        directoryAccountStatusData: [],
        directoryAccountStatusDataTotalDebt: 0,
        listCorreos: [],
        correoElectronico: "",
      }    
    },
    components: {
      Icon,
      RightSideBar
    },
    methods: {
      async getData(){
        try {
          const data = await this.accountStatus(this, this.selectedDirectory.id_Directorio)

          this.directoryAccountStatusDataTotalDebt = data.response ? data.response.Total_Deuda : 0
          this.directoryAccountStatusData = data.response ? data.response.Movimientos : data 
        } catch (error) {
          console.log(error)
          this.$store.commit('setAlert', {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          })
        }
      },
      async downloadStatementAccount(typeDocument) {
        this.loading_excel = true

        try {
          const { errorCode, errorMessage, response } = await descargaEstadoCuentaExcel(this, this.selectedDirectory.id_Directorio, "Cliente", typeDocument)

          if (errorCode === 0) {
            const { nombreArchivo, contenidoArchivo } = response

            downloadFileObject(nombreArchivo, typeDocument, contenidoArchivo)
          } else {
            this.$store.commit("setAlert", {
              color: "warning",
              message: `Error: ${errorCode} - ${errorMessage}`,
              show: 5
            })
          }
        } catch(error) {
          console.log(error);
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Ocurrio un error al descargar el archivo del cliente.",
            show: 5
          })
        } finally {
          this.loading_excel = false
        }
      },
      async sendMailStatementAccount() {
        this.loading_email = true

        try {
          let strListaCorreos = this.listCorreos.toString()

          const { errorCode, errorMessage } = await enviarEstadoCuenta(this, this.selectedDirectory.id_Directorio, strListaCorreos)

          if (errorCode === 0) {
            this.listCorreos.length = 0

            this.$store.commit("setAlert", {
              color: "success",
              message: "Se envió el correo electrónico con el estado de cuenta.",
              show: 5
            })
          } else {
            this.$store.commit("setAlert", {
              color: "warning",
              message: `Error: ${errorCode} - ${errorMessage}`,
              show: 5
            })
          }
        } catch(error) {
          console.log(error)
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Ocurrio un error al enviar el correo electrónico al cliente.",
            show: 5
          })
        } finally {
          this.loading_email = false
          this.showRightSideBar = null
        }
      },
      addMailToList() {
        if (this.correoElectronico) {
          this.listCorreos.push(this.correoElectronico)
          this.correoElectronico = ""
        }
      }
    },
    computed: {
      selectedDirectory() {
        return this.$store.state.selectedDirectory
      },
      accountStatus(){
        if(this.type === 'CL') return dataGridEstadoCuentaCliente
        if(this.type === 'PR') return dataGridEstadoCuentaProveedor

        return dataGridEstadoCuentaCliente
      }
    },
    mounted(){
      this.getData()
    }
  }
</script>
